export const resetModellingTask = () => ({
  type: 'MODELLING_RESET',
});
export const resetModellingList = () => ({
  type: 'MODELLING_LIST_RESET',
});
export const resetCreateModellingFlag = () => ({
  type: 'MODELLING_RESET_CREATE_FLAG',
});
